import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Login from "../pages/auth/Login";
import MainPage from "../pages/main-pages/MainPage";
import Dashboard from "../pages/main-pages/dashboard/Dashboard";

import Users from "../pages/main-pages/users/Users";
import UserDetails from "../pages/main-pages/users/user-detail/UserDetails";
import WeeklyReport from "../pages/main-pages/users/weekly-reports/WeeklyReport";
import UserMessages from "../pages/main-pages/users/user-message/UserMessages";
import UserFeedback from "../pages/main-pages/users/user-feedback/UserFeedback";

import UserRequests from "../pages/main-pages/user-requests/UserRequests";
import UserGroups from "../pages/main-pages/user-groups/UserGroups";
import DeliveredMessages from "../pages/main-pages/delevered-messages/DeliveredMessages";
import Questions from "../pages/main-pages/questions/Questions";
import AccessControl from "../pages/main-pages/access-control/AccessControl";
import MessageTemplate from "../pages/main-pages/message-templates/MessageTemplate";

import ResourceMain from "../pages/main-pages/resources/ResourceMain";
import ResourceDetails from "../pages/main-pages/resources/resourse-details/ResourceDetails";
import CreateAndEditResource from "../pages/main-pages/resources/create-editResource/CreateAndEditResource";

import Lessons from "../pages/main-pages/lessons/Lessons";
import CreateEditLesson from "../pages/main-pages/lessons/create-edit-lessons/CreateEditLesson";
import LessonDetails from "../pages/main-pages/lessons/lessons-details/LessonDetails";

const AppRoutes: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    localStorage.getItem("isAuthenticated") === "true" &&
      Boolean(localStorage.getItem("accessToken")),
  );

  return (
    <Routes>
      {/* ✅ Public Login */}
      <Route
        path="/login"
        element={
          isAuthenticated ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <Login setIsAuthenticated={setIsAuthenticated} />
          )
        }
      />
      {/* ✅ Public Dashboard (SSO entry point) */}
      <Route
        path="/dashboard"
        element={
          <Dashboard
            setIsAuthenticated={setIsAuthenticated}
            isAuthenticated={isAuthenticated}
          />
        }
      />
      {/* ✅ Protected Routes */}
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <MainPage setIsAuthenticated={setIsAuthenticated} />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      >
        {/* default redirect */}
        <Route index element={<Navigate to="/dashboard" replace />} />
        {/* <Route
          path="/dashboard"
          element={<Dashboard setIsAuthenticated={setIsAuthenticated} />}
        /> */}
        <Route path="users" element={<Users />} />
        <Route path="users/:name/:userDetailId" element={<UserDetails />} />
        <Route path="users/:name/messages/:userId" element={<UserMessages />} />
        <Route
          path="users/:name/:userId/feedbacks"
          element={<UserFeedback />}
        />
        <Route
          path="users/:name/:userDetailId/weekly-reports/:reportId"
          element={<WeeklyReport />}
        />

        <Route path="user-request" element={<UserRequests />} />
        <Route path="user-group" element={<UserGroups />} />
        <Route path="messages" element={<DeliveredMessages />} />

        <Route path="lessons" element={<Lessons />} />
        <Route path="lessons/create" element={<CreateEditLesson />} />
        <Route path="lessons/edit/:lessonId" element={<CreateEditLesson />} />
        <Route path="lessons/details/:lessonId" element={<LessonDetails />} />

        <Route path="resources" element={<ResourceMain />} />
        <Route path="resources/create" element={<CreateAndEditResource />} />
        <Route
          path="resources/edit/:resourceId"
          element={<CreateAndEditResource />}
        />
        <Route
          path="resource-details/:resourceId"
          element={<ResourceDetails />}
        />

        <Route path="questions" element={<Questions />} />
        <Route path="message-template" element={<MessageTemplate />} />
        <Route path="access-control" element={<AccessControl />} />
      </Route>
      {/* ✅ Catch-all */}
      <Route
        path="*"
        element={
          <Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />
        }
      />
    </Routes>
  );
};

export default AppRoutes;
